// extracted by mini-css-extract-plugin
export default {"image":"AVoice_image__L724-"};